export const isValidHttpUrl = (str: string): boolean => {
  let url: URL

  try {
    url = new URL(str)
  } catch (_) {
    return false
  }

  return url.protocol === 'http:' || url.protocol === 'https:'
}

export const isValidIDNUrl = (str: string): boolean => {
  try {
    const httpCheckPattern = new RegExp('^(https?:\\/\\/)', 'i')
    if (!httpCheckPattern.test(str)) {
      str = `https://${str}`
    }

    const url = new URL(str)

    const pattern = new RegExp(
      '^(https?:\\/\\/)?' +
        '((([a-z\\d-]([a-z\\d-]*[a-z\\d-])*)\\.)+[a-z\\d-]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$',
      'i'
    )

    return pattern.test(url.href)
  } catch (e) {
    return false
  }
}
